import classNames from 'classnames';
import React from 'react';

import { AlmaLink } from '../alma-link';
import * as styles from './blog-banner-cta.module.css';

type LinkType =
	| 'directoryLink'
	| 'externalLink'
	| 'internalLink'
	| 'iterablePopup'
	| 'marketoPopup';

interface BlogBannerCtaProps {
	ctaAudience: string;
	ctaDescription: string;
	ctaHeading: string;
	ctaLinkLabel: string;
	ctaStyle: string;
	iterablePopup?: string;
	landingPageRoute: string;
	link: string;
	linkType: LinkType;
	marketoPopup?: string;
	openInNewTab: boolean;
	route: string;
}

export const BlogBannerCta: React.FC<BlogBannerCtaProps> = ({
	ctaAudience,
	ctaDescription,
	ctaHeading,
	ctaLinkLabel,
	ctaStyle,
	iterablePopup,
	landingPageRoute,
	link,
	linkType,
	marketoPopup,
	openInNewTab,
	route,
}) => {
	const isDirectoryLink = linkType === 'directoryLink';
	const isExternalLink = linkType === 'externalLink';
	const isInternalLink = linkType === 'internalLink';
	const isIterablePopup = linkType === 'iterablePopup';
	const isMarketoPopup = linkType === 'marketoPopup';
	const isProviderCta = ctaAudience === 'provider';
	const subduedStyle = ctaStyle === 'subdued';

	return (
		<div
			className={classNames(
				styles.container,
				isProviderCta ? styles.providerCta : styles.consumerCta,
				styles[`${ctaStyle}Background`]
			)}
		>
			<div className={styles.headerContent}>
				<h2 className={styles.heading}>{ctaHeading}</h2>
				<p className={classNames(styles.description, 'body-s')}>
					{ctaDescription}
				</p>
			</div>
			<AlmaLink
				analytics={{
					enableGA4: isIterablePopup || isDirectoryLink,
					ga4Event: {
						name: isIterablePopup
							? 'article_Iterable_CTA_btn'
							: 'blog_directory_CTA_btn',
					},
				}}
				cta={{
					buttonColorTheme: isProviderCta
						? subduedStyle
							? 'blue'
							: 'mediumBlue'
						: subduedStyle
							? 'dark'
							: 'darkForest',
					iterablePopup: isIterablePopup ? iterablePopup : undefined,
					kind: 'button',
					landingPageRoute: isInternalLink
						? landingPageRoute
						: undefined,
					link: isDirectoryLink || isExternalLink ? link : undefined,
					marketoPopup: isMarketoPopup ? marketoPopup : undefined,
					openInNewTab:
						isDirectoryLink || isExternalLink
							? openInNewTab
							: undefined,
					route: isInternalLink ? route : undefined,
					title: ctaLinkLabel,
				}}
			/>
		</div>
	);
};
